import { Component, EventEmitter, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  IonButton,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { powerOutline } from 'ionicons/icons';

import { ContactService } from 'src/app/services/contact.service';
import { AuthService } from 'src/lib/lib-ngx/web-services/auth.service';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonList,
    IonLabel,
    IonItem,
    IonIcon,
    TranslateModule,
    RouterModule,
    IonButton,
  ],
})
export class MenuComponent {
  constructor(
    private authService: AuthService,
    public contactService: ContactService,
    private router: Router
  ) {
    addIcons({
      powerOutline,
    });
  }

  @Output() itemClicked = new EventEmitter<void>();

  logout() {
    this.authService.logout();
    this.router.navigate(['/onboarding'], { replaceUrl: true });
    this.itemClicked.emit();
  }

  navigate(route: string) {
    this.router.navigate([route]);
    this.itemClicked.emit();
  }
}
